var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 2.89282C6.97047 2.89282 2.89307 6.97023 2.89307 12C2.89307 17.0297 6.97047 21.1071 12.0002 21.1071C17.0299 21.1071 21.1074 17.0297 21.1074 12C21.1074 6.97023 17.0299 2.89282 12.0002 2.89282ZM1.39307 12C1.39307 6.1418 6.14205 1.39282 12.0002 1.39282C17.8584 1.39282 22.6074 6.1418 22.6074 12C22.6074 17.8581 17.8584 22.6071 12.0002 22.6071C6.14205 22.6071 1.39307 17.8581 1.39307 12Z",
    fill: "#265EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0003 4.60706C7.91732 4.60706 4.60742 7.91695 4.60742 11.9999C4.60742 16.0829 7.91732 19.3928 12.0003 19.3928C16.0832 19.3928 19.3931 16.0829 19.3931 11.9999C19.3931 7.91695 16.0832 4.60706 12.0003 4.60706ZM3.10742 11.9999C3.10742 7.08852 7.08889 3.10706 12.0003 3.10706C16.9117 3.10706 20.8931 7.08852 20.8931 11.9999C20.8931 16.9113 16.9117 20.8928 12.0003 20.8928C7.08889 20.8928 3.10742 16.9113 3.10742 11.9999Z",
    fill: "#67C2E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1748 8.94538C15.4677 9.23827 15.4677 9.71314 15.1748 10.006L13.3062 11.8746C13.0133 12.1675 12.5384 12.1675 12.2455 11.8746C11.9527 11.5817 11.9527 11.1069 12.2455 10.814L14.1141 8.94538C14.407 8.65249 14.8819 8.65248 15.1748 8.94538Z",
    fill: "#67C2E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.72571C12.4142 5.72571 12.75 6.06149 12.75 6.47571V10.9157C12.75 11.3299 12.4142 11.6657 12 11.6657C11.5858 11.6657 11.25 11.3299 11.25 10.9157V6.47571C11.25 6.06149 11.5858 5.72571 12 5.72571Z",
    fill: "#67C2E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 11.8928C11.941 11.8928 11.8931 11.9408 11.8931 12C11.8931 12.0591 11.941 12.1071 12.0002 12.1071C12.0594 12.1071 12.1074 12.0591 12.1074 12C12.1074 11.9408 12.0594 11.8928 12.0002 11.8928ZM10.3931 12C10.3931 11.1124 11.1126 10.3928 12.0002 10.3928C12.8878 10.3928 13.6074 11.1124 13.6074 12C13.6074 12.8876 12.8878 13.6071 12.0002 13.6071C11.1126 13.6071 10.3931 12.8876 10.3931 12Z",
    fill: "#265EA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.8d4f29023b78497b1d7bb237aa9f216c.svg";
export { ForwardRef as ReactComponent };